import React from 'react'
import colors from '@sportninja/common/constants/appColors'

interface GenderIconProps {
  size?: number
  color?: string
  title?: string
}

/**
 * GenderIcon renders the gender SVG with customizable size and color.
 */
const GenderIcon: React.FC<GenderIconProps> = ({
  size = 16,
  color = colors.PRIMARY,
  title,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      role={title ? 'img' : 'presentation'}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable='false'
    >
      {title ? <title>{title}</title> : null}
      <path
        d='M6.33341 10C6.97786 10 7.52786 9.77224 7.98341 9.31669C8.43897 8.86113 8.66675 8.31113 8.66675 7.66669C8.66675 7.02224 8.43897 6.47224 7.98341 6.01669C7.52786 5.56113 6.97786 5.33335 6.33341 5.33335C5.68897 5.33335 5.13897 5.56113 4.68341 6.01669C4.22786 6.47224 4.00008 7.02224 4.00008 7.66669C4.00008 8.31113 4.22786 8.86113 4.68341 9.31669C5.13897 9.77224 5.68897 10 6.33341 10ZM6.33341 15.3334C6.14453 15.3334 5.9863 15.2694 5.85875 15.1414C5.73075 15.0138 5.66675 14.8556 5.66675 14.6667V14H5.00008C4.81119 14 4.65297 13.936 4.52541 13.808C4.39741 13.6805 4.33341 13.5222 4.33341 13.3334C4.33341 13.1445 4.39741 12.9862 4.52541 12.8587C4.65297 12.7307 4.81119 12.6667 5.00008 12.6667H5.66675V11.2667C4.81119 11.1111 4.09741 10.6971 3.52541 10.0247C2.95297 9.35269 2.66675 8.56669 2.66675 7.66669C2.66675 7.2778 2.7223 6.90824 2.83341 6.55802C2.94453 6.20824 3.10008 5.88891 3.30008 5.60002C3.59439 5.1749 3.7191 5.05022 4.26675 4.65002C4.55564 4.43891 4.87519 4.2778 5.22541 4.16669C5.57519 4.05558 5.94453 4.00002 6.33341 4.00002C6.7223 4.00002 7.09186 4.05558 7.44208 4.16669C7.79186 4.2778 8.11119 4.43891 8.40008 4.65002L11.0501 2.00002H10.0001C9.81119 2.00002 9.65297 1.93602 9.52541 1.80802C9.39741 1.68046 9.33341 1.52224 9.33341 1.33335C9.33341 1.14446 9.39741 0.98602 9.52541 0.85802C9.65297 0.730465 9.81119 0.666687 10.0001 0.666687H12.6667C12.8556 0.666687 13.0139 0.730465 13.1414 0.85802C13.2694 0.98602 13.3334 1.14446 13.3334 1.33335V4.00002C13.3334 4.18891 13.2694 4.34735 13.1414 4.47535C13.0139 4.60291 12.8556 4.66669 12.6667 4.66669C12.4779 4.66669 12.3196 4.60291 12.1921 4.47535C12.0641 4.34735 12.0001 4.18891 12.0001 4.00002V2.95002L9.35008 5.58335C9.56119 5.88335 9.7223 6.20824 9.83341 6.55802C9.94452 6.90824 10.0001 7.2778 10.0001 7.66669C10.0001 8.56669 9.71386 9.35269 9.14141 10.0247C8.56941 10.6971 7.85564 11.1111 7.00008 11.2667V12.6667H7.66675C7.85564 12.6667 8.01408 12.7307 8.14208 12.8587C8.26964 12.9862 8.33341 13.1445 8.33341 13.3334C8.33341 13.5222 8.26964 13.6805 8.14208 13.808C8.01408 13.936 7.85564 14 7.66675 14H7.00008V14.6667C7.00008 14.8556 6.9363 15.0138 6.80875 15.1414C6.68075 15.2694 6.5223 15.3334 6.33341 15.3334Z'
        fill={color}
      />
    </svg>
  )
}

export default GenderIcon
